export default __webpack_public_path__ + "static/media/5.9c29acf6.jpg";